import { apiCaller, checkStatusResponse, notifyToast } from "../helpers";
import { setStateAdmin } from "./admins";
import _ from "lodash";

const initialState = {
  Shareholder: {},
  Categories: {},
  isCategories: false,
  listParentCategoriesVi: [],
  listParentCategoriesEn: [],
  listParent: [],
  listParent2: [],
  totalCount: 0,
  totalPage: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_POST":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_POST":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

// set state dashboard
export function setStateShareholder(propertyName, value) {
  return {
    type: "SET_STATE_POST",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStateShareholder(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_POST",
    newObject,
  };
}

export function getShareholder(page, pageSize, query) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      // const res = await apiCaller(
      //   `/api/service?queryString=${query}&userName=null&pageIndex=${page}&pageSize=${pageSize}`,
      //   'GET',
      //   null
      // )
      const res = await apiCaller(`/api/shareHolder`, "GET", null);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateShareholder("Shareholder", res.data.response.data));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function toggleStatus(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/post/updatestatuspost`, "PUT", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Cập nhật trạng thái thành công");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function addShareholder(body) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(`/api/post/addpost`, "POST", body);
      console.log(res);
      dispatch(setStateAdmin("loading", false));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deleteShareholder(shareHolderId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/shareHolder?shareHolderId=${shareHolderId}`,
        "DELETE",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa Cổ đông thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function getAllCategories() {
  return async (dispatch) => {
    try {
      // const res = await apiCaller(
      //   `/api/servicecategory?queryString=${query}&pageIndex=${page}&pageSize=${pageSize}&fromDate=2020/1/1&toDate=2020/10/10`,
      //   "GET",
      //   null
      // );
      const res = await apiCaller(
        `/api/servicecategory?pageSize=1000000`,
        "GET",
        null
      );
      // debugger
      // console.log(res);
      const { response } = res.data;

      if (_.isEmpty(response.data)) {
        dispatch(setStateShareholder("listParent2", []));
      } else {
        for (let p in response.data[0].breadCrumb) {
          console.log(response.data[0].breadCrumb[p]);
        }

        let target = response.data.map((o) => {
          let label = [];
          o.breadCrumb = _.sortBy(o.breadCrumb, []);
          for (let p in o.breadCrumb) {
            label.push(o.breadCrumb[p]);
          }
          let label2 = label.join(" >> ");
          if (!label2) {
            label2 = o.name;
          } else {
            label2 = `${label2} >> ${o.name}`;
          }
          o.label = label2;
          return o;
        });
        console.log("target :", target);
        dispatch(setStateShareholder("listParent2", target));
      }
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

// categories
export function getCategories(page, pageSize, query, selectedLangId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      // const res = await apiCaller(
      //   `/api/servicecategory?queryString=${query}&pageIndex=${page}&pageSize=${pageSize}&fromDate=2020/1/1&toDate=2020/10/10`,
      //   "GET",
      //   null
      // );
      let url;
      if (query) {
        url = `/api/categoryShareHolder?pageIndex=${page}&pageSize=10&sortDir=ASC&queryString=${query}&langIdlanguageId=${selectedLangId}`;
      } else {
        url = `/api/categoryShareHolder?pageIndex=${page}&pageSize=10&sortDir=ASC&languageId=${selectedLangId}`;
      }
      const res = await apiCaller(url, "GET", null);
      // console.log(res);
      const { response } = res.data;
      const arrVi = _.filter(response.data, (item) => {
        return item.langId === 1;
      });
      const arrEn = _.filter(response.data, (item) => {
        return item.langId === 2;
      });
      dispatch(setStateAdmin("loading", false));
      dispatch(
        setMultipleStateShareholder({
          Categories: response,
          isCategories: false,
          listParentCategoriesVi: arrVi,
          listParentCategoriesEn: arrEn,
          totalCount: response.totalCount,
          totalPage: response.totalPage,
        })
      );
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function deleteCategories(id) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/categoryShareHolder?serviceCategoryId=${id}`,
        "DELETE",
        null
      );
      // console.log(res);
      dispatch(setStateAdmin("loading", false));
      notifyToast("success", "Xóa chuyên mục thành công!");
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}

export function getParentCategories(langId) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/category/getcategorytreebylangId?langId=${langId}`,
        "GET",
        null
      );
      console.log(res);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateShareholder("listParent", res.data.response));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
